module.exports = "https://coursera_assets.s3.amazonaws.com/images/74008f42837181eec1cbd128b5c888a2.png";